import { useCountDown } from "@roman/shared/hooks/useCountDown";
import { cn, formatTimestamp } from "@roman/shared/utils";
import { differenceInHours, differenceInSeconds } from "date-fns";

export const DeadlineTime = ({
  entryCloseTime,
  className,
  showWeekday = true,
}: {
  entryCloseTime: number;
  className?: string;
  showWeekday?: boolean;
}) => {
  const { deadlineTime: remainingTime } = useCountDown(new Date(entryCloseTime));

  const remainHours = differenceInHours(entryCloseTime, Date.now());
  const remainSeconds = differenceInSeconds(entryCloseTime, Date.now());
  const showCountDown = remainSeconds > 0 && remainHours < 24;

  return (
    <span className={cn(className ? className : "font-bold text-xs whitespace-nowrap w-full")}>
      {showCountDown ? remainingTime : formatTimestamp(entryCloseTime, { showWeekday })}
    </span>
  );
};
